import RelatedLinksNPM from '@rotaryintl/component-related-links';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { createLink } from '../../utilities/link-helpers';

const RelatedLinks = ({ params: { ComponentId } = {}, fields: { Title, Description, children: RelatedLinks } = {} }) => (
  <RelatedLinksNPM
    id={ComponentId}
    title={<Text field={Title} />}
    description={<Text field={Description} />}
    linkList={RelatedLinks?.map(({ fields: { Link, LinkText, ShowExternalLinkIcon } = {} }) => createLink(Link, LinkText, ShowExternalLinkIcon))}
  />
);

export default withSitecoreContext()(RelatedLinks);
